import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=3d684f2f&scoped=true"
import script from "./nurse.vue?vue&type=script&lang=js"
export * from "./nurse.vue?vue&type=script&lang=js"
import style0 from "./nurse.vue?vue&type=style&index=0&id=3d684f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d684f2f",
  null
  
)

export default component.exports